import { Autocomplete, AutocompleteChangeReason, Chip } from "@mui/material";
import { Checkbox } from "components/Form/components/Checkbox/Checkbox";
import "components/RoleSelect/RoleSelect.scss";
import { getRelativeUrl } from "utils/service";

interface RoleSelectAutocompleteProps {
    options: any[];
    selectedValue: any;
    renderInput: (params: any) => React.ReactNode;
    onDelete: (event: React.ChangeEvent<HTMLInputElement>, value: any) => void;
    onPropagateChange: (event: React.ChangeEvent<HTMLInputElement>, value: any) => void;
    onAddRole: (
        event: React.SyntheticEvent,
        value: any[],
        reason: AutocompleteChangeReason
    ) => void;
    isDisabled?: boolean;
    isLoading?: boolean;
    disablePortal?: boolean;
}

export const RoleSelectAutocomplete = ({
    options,
    selectedValue,
    renderInput,
    onDelete,
    onPropagateChange,
    onAddRole,
    isDisabled,
    isLoading,
    disablePortal,
}: RoleSelectAutocompleteProps) => {
    return (
        <Autocomplete
            multiple
            limitTags={10}
            id="multiple-limit-tags"
            options={options}
            getOptionLabel={(option) => option.role_id_role?.name ?? option.name}
            value={selectedValue}
            disableClearable
            loading={isLoading}
            disabled={isDisabled}
            disablePortal={disablePortal}
            sx={{ width: "400px" }}
            renderInput={renderInput}
            renderTags={(value: any) => {
                return value.map((val: any) => (
                    <Chip
                        className="chip"
                        key={`roleSelectRoleChip${val.id}`}
                        label={
                            <span>
                                <a href={getRelativeUrl("role", val.role_id_role?.id ?? val.id)}>
                                    {val.role_id_role?.name ?? val.name}
                                </a>
                            </span>
                        }
                        onDelete={(e) => onDelete(e, val)}
                        icon={
                            <Checkbox
                                className="propagateCheckbox"
                                value={val.propagate}
                                onChange={(e) => onPropagateChange(e, val)}
                                label="propagate"
                            />
                        }
                        disabled={isDisabled}
                    ></Chip>
                ));
            }}
            onChange={onAddRole}
        />
    );
};
